<template>
  <div class="tw-flex tw-flex-col tw-items-center">
    <img
      class="tw-inline tw-w-2/5 tw-pt-5 tw-text-center md:tw-w-1/5 tw-pb-9"
      src="~@/assets/MySideline_ManagerLogo.svg"
    />

    <div class="tw-flex tw-flex-col tw-items-center tw-w-full tw-px-5 tw-pb-5 sm:tw-w-3/5">
      <p class="tw-pb-8 tw-m-4 tw-text-center">
        Welcome to the new MySideline Manager! Select from the Game Day functions below to get
        started.
      </p>
      <div class="tw-w-full">
        <div
          class="tw-grid tw-w-full tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-2"
          v-if="clearance !== roles.programAdmin"
        >
          <div style="text-align: left" class="tw-w-full">
            <button id="teams" size="small" @click="$router.push('/team-lists')">
              Team Lists
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4 tw-ml-auto"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div style="text-align: right">
            <button class="tw-w-full" id="matches" size="small" @click="$router.push('/matches')">
              Matches
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4 tw-ml-auto"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div style="text-align: right" v-if="clearance === roles.clubAdmin">
            <button
              class="tw-w-full"
              id="squad"
              size="small"
              @click="$router.push('/squad-management')"
            >
              Squads<svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4 tw-ml-auto"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div style="text-align: right" v-if="clearance !== roles.gamedayAdmin">
            <button
              class="tw-w-full"
              id="members"
              size="small"
              @click="$router.push('/my-members')"
            >
              My Members<svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4 tw-ml-auto"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div style="text-align: right" v-if="clearance !== roles.gamedayAdmin">
            <button
              class="tw-w-full"
              id="attendance"
              size="small"
              @click="$router.push('/training-participants')"
            >
              Attendance<svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4 tw-ml-auto"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div
            style="text-align: right"
            v-if="
              clearance === roles.clubAdmin ||
              clearance === roles.teamAdmin ||
              clearance === roles.programAdmin
            "
          >
            <button
              class="tw-w-full"
              id="injury"
              size="small"
              @click="$router.push('/injury-cases')"
            >
              Injury Cases<svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4 tw-ml-auto"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div
            style="text-align: right"
            v-if="
              clearance === roles.clubAdmin ||
              clearance === roles.teamAdmin ||
              clearance === roles.programAdmin
            "
          >
            <button
              class="tw-w-full"
              id="report"
              size="small"
              @click="$router.push('/injury-cases-add')"
            >
              Report Injury<svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4 tw-ml-auto"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "@/utils/dayjs";
import { roles } from "../../utils/constants";

export default {
  name: "Dashboard",
  props: {},
  data() {
    return {
      roles,
    };
  },
  methods: {},
  computed: {
    time() {
      return dayjs("19-12-2019, 5:00:00 pm", "DD-MM-YYYY, h:mm a").format("MMMM Do YYYY, h:mm a");
    },
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-btn-list {
  .el-button {
    width: 100%;
    padding-right: 15px !important;
    padding-left: 15px !important;
    font-size: 0.7rem;
  }
}
.container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  text-align: center;

  img {
    width: 40%;

    @media (min-width: $sm) {
      width: 20%;
    }
  }

  .card {
    margin: 20px auto;
    width: 60%;
    max-width: 100%;
    overflow: hidden;
    text-align: center;

    .datetime {
      text-align: left;
      margin-bottom: 2rem;
    }

    .content {
      text-align: left;
    }

    .box {
      background-color: $tint;
      color: white;
      border-radius: 10%;
      padding: 4px;
      font-family: $fontBold;
    }

    .program-admin-only {
      display: flex;
      justify-content: center;
    }
  }

  @media only screen and (max-width: $sm) {
    .card {
      width: 95%;
    }
  }
}
@media only screen and (max-width: 767px) {
  .custom-btn-list.el-row .el-col.el-col-12 {
    width: 100%;
  }
  .el-row.custom-btn-list {
    margin-top: 0px;
    margin-bottom: 8px;
  }
  .el-row.custom-btn-list .el-col.el-col-12:first-child {
    margin-bottom: 8px;
  }
}

.dashboard button span i {
  font-size: 20px;
  font-weight: bold;
  vertical-align: middle;
  position: absolute;
  right: 10px;
  top: 6px;
}
.dashboard button {
  position: relative;
  text-align: left;
}

button {
  @apply tw-w-full tw-flex tw-text-left tw-h-12 tw-p-4 tw-bg-white tw-border tw-box-border tw-rounded-sm tw-shadow-md hover:tw-shadow-lg tw-transition-shadow tw-border-gray-200 tw-font-normal tw-text-base tw-leading-4 tw-text-black;
}
</style>
